import { render, staticRenderFns } from "./HCT.vue?vue&type=template&id=64be94e2&scoped=true&"
import script from "./HCT.vue?vue&type=script&lang=js&"
export * from "./HCT.vue?vue&type=script&lang=js&"
import style0 from "./HCT.vue?vue&type=style&index=0&id=64be94e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be94e2",
  null
  
)

export default component.exports